import {Pipe, PipeTransform} from '@angular/core';



@Pipe({name: 'trimComments'})
export class TrimCommentsPipe implements PipeTransform {
  
  constructor() {
    
  }

  transform(comment: string) {
    
    if(comment === null){
      return '';
    }

    if (comment === '') {
      return '';
    }

    const lengthToReturn = 25;
    let modifiedComment: string = comment;
      
    if(comment.length > lengthToReturn){
        modifiedComment = comment.substring(0, lengthToReturn) + '...';
    }

    return modifiedComment;
  }
}